import { useFormContext } from "react-hook-form";
import { FormControl, Grid } from "@mui/material";
import { VRSTA_ZAHTJEVA } from "../../../../enums";
import { DragAndDrop, PorukaGreskePolja } from "../../../index";

const Index = (props: any) => {
  const { register, getValues } = useFormContext();
  const vrstaZahtjeva = getValues("vrstaZahtjeva");

  if (vrstaZahtjeva === VRSTA_ZAHTJEVA.REGISTRACIJA) return null;

  return (
    <Grid item xs={12} sx={{ mt: 3 }}>
      <FormControl fullWidth variant="outlined">
        <DragAndDrop
          nazivPolja={"dokumentOIskljucenju"}
          label={"Dokument o isključenju* (Exclusion document)"}
        />
      </FormControl>
      <PorukaGreskePolja
        nazivPolja={"iskljuciOperatera.dokumentOIskljucenju"}
      />
    </Grid>
  );
};

export default Index;
